import apiClient from '@/api/apiClient';
import type { PersonSearchResult, PersonBasicData, PersonFinancialData, ExtendedDataStatus } from '@/types/person';
import { DATA_UNIT_PRODUCT_KEYS } from '@/constants/dataUnitProducts';

interface LookupResponse {
  data: PersonSearchResult[];
  total: number;
  offset: number;
  limit: number;
}

interface BasicDataStatusResponse {
  has_access: boolean;
  cpf: string | null;
}

interface FinancialDataStatusResponse {
  has_access: boolean;
}

interface BasicDataRequestResponse {
  success: boolean;
  message: string;
}

export type ExtendedDataProductKey =
  | typeof DATA_UNIT_PRODUCT_KEYS.personAddresses
  | typeof DATA_UNIT_PRODUCT_KEYS.personPhones
  | typeof DATA_UNIT_PRODUCT_KEYS.personEmails;

export default {
  lookup(tax_id: string, offset = 0, limit = 10): Promise<LookupResponse> {
    return apiClient.get('/persons/lookup', {
      params: { tax_id, offset, limit }
    });
  },

  getBasicData(uuid: string): Promise<PersonBasicData> {
    return apiClient.get(`/persons/${uuid}/basic-data`);
  },

  getFinancialData(uuid: string): Promise<PersonFinancialData> {
    return apiClient.get(`/persons/${uuid}/financial-data`);
  },

  getFinancialDataStatus(uuid: string): Promise<FinancialDataStatusResponse> {
    return apiClient.get(`/persons/${uuid}/financial-data/status`);
  },

  requestFinancialData(uuid: string): Promise<BasicDataRequestResponse> {
    return apiClient.post(`/persons/${uuid}/financial-data/request`, {});
  },

  getBasicDataStatus(uuid: string): Promise<BasicDataStatusResponse> {
    return apiClient.get(`/persons/${uuid}/basic-data/status`);
  },

  requestBasicData(uuid: string): Promise<BasicDataRequestResponse> {
    return apiClient.post(`/persons/${uuid}/basic-data/request`, {});
  },

  // Extended data endpoints
  getExtendedDataStatus(uuid: string): Promise<ExtendedDataStatus> {
    return apiClient.get(`/persons/${uuid}/extended-data/status`);
  },

  requestExtendedData(uuid: string, datasets: ExtendedDataProductKey[]): Promise<BasicDataRequestResponse> {
    return apiClient.post(`/persons/${uuid}/extended-data/request`, { datasets });
  }
};
